import "./index.css";
import logo from "./logo.svg";

export function App() {
  return (
    <div className="landing">
      <div className="logo-wrapper">
        <img src={logo} alt="SiteChatAgent Logo" className="logo" />
      </div>
      <h1 className="brand">SiteChatAgent</h1>
      <p className="coming-soon">Coming Soon</p>
      <p className="contact">
        Curious or have questions? Email us at{" "}
        <a className="contact-link" href="mailto:hello@novaspark.dev">
          hello@novaspark.dev
        </a>
      </p>
    </div>
  );
}

export default App;
